import React, { Component, useState, useEffect } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter, useHistory } from "react-router-dom";
import "react-phone-number-input/style.css";
import { AiOutlinePlayCircle, AiOutlineRight } from "react-icons/ai";
import { useLoading } from "../Context/LoadingContext";
import { BsPlayCircle } from "react-icons/bs";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { BiRightArrowAlt } from "react-icons/bi";

const Section1 = ({ selectedPackage, setSelectedPackage, requestLoading }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  if (requestLoading === true) {
    return null;
  }

  const packages = [
    {
      id: 1,
      credits: "5 video credits",
      description: "Unlock all celebrities and custom cloning.",
      price: "$10",
      width: "90vw", // Width differs for the first package
    },
    {
      id: 2,
      credits: "20 video credits - Most Popular",
      description: "Unlock all celebrities and custom cloning.",
      price: "$15",
      width: "90vw",
    },
    {
      id: 3,
      credits: "30 video credits",
      description: "Unlock all celebrities and custom cloning.",
      price: "$20",
      width: "90vw",
    },
  ];

  return (
    <>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSBold",
            fontSize: "3.7vw",
            color: "rgb(255, 215, 0)",
            marginTop: 20,
          }}
        >
          Unlock celebrities and custom cloning
        </p>
      </MDBCol>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSBold",
            marginTop: -10,
            textAlign: "center",
            lineHeight: 1.3,
            fontSize: "5.7vw",
          }}
        >
          Choose your package
        </p>
      </MDBCol>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSMedium",
            textAlign: "center",
            marginTop: -5,
            fontSize: "3.6vw",
          }}
        >
          Choose your package below to purchase credits
        </p>
      </MDBCol>
      {packages.map((pkg) => (
        <MDBCol className="d-flex justify-content-center" size="12">
          <div
            style={{
              height: 80,
              width: pkg.width,
              backgroundColor:
                selectedPackage === pkg.id
                  ? "rgba(255, 215, 0, 0.1)"
                  : "#201e23",
              borderRadius: 6,
              border:
                selectedPackage === pkg.id
                  ? "2px solid rgb(255, 215, 0)"
                  : "1px solid #3d3943",
              paddingLeft: 20,
              paddingRight: 20,
              cursor: "pointer",
              marginTop: pkg.id === 1 ? 24 : 15, // Adjust top margin for the first package
            }}
            onClick={() => setSelectedPackage(pkg.id)}
            className="d-flex justify-content-between"
          >
            <div>
              <p
                style={{
                  fontFamily: "CSMedium",
                  color: "white",
                  marginTop: 19,
                  fontSize: "4vw",
                }}
              >
                {pkg.credits}
              </p>
              <p
                style={{
                  fontFamily: "CSRegular",
                  color: "rgb(191, 186, 196)",
                  marginTop: -16,
                  fontSize: "3vw",
                }}
              >
                {pkg.description}
              </p>
            </div>
            <p
              style={{
                fontFamily: "CSBold",
                fontSize: "5vw",
                color: "white",
                marginTop: 20,
              }}
            >
              {pkg.price}
            </p>
          </div>
        </MDBCol>
      ))}
    </>
  );
};

export default withRouter(Section1);
